<mat-tab-group mat-align-tabs="center">
  <mat-tab label="Habilitados ({{ activeArrData.length }})">
    <perfect-scrollbar class="slides-scrollbar"
      [config]="{useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true}">
      <div class="slides-content">
        <div *ngFor="let banner of activeArrData, index as i">
          <mat-card class="banner has-outline-menu slider">
            <div class="vs-crud-menu">
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Editar Banner"
                (click)="editSlider(banner)">
                <mat-icon>edit</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                [matTooltip]="banner.status === 'Activo' ? 'Deshabilitar Banner' :  'Habilitar Banner'"
                (click)="changeStatus(banner, banner.status)">
                <mat-icon>{{ banner.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Banner"
                (click)="deleteFromEnable(banner)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
            <!-- <p>{{banner.orderId}}.</p> -->
            <h4 class="blue-text text-center" *ngIf="banner.orderId === 1">Slider Principal</h4>
            <div class="row text-center">
              <div class="col-12 mb-5">
                <img [src]="banner.img" class="banner-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
              <div class=" col-12">
                <p class="input-label">Título</p>
                <h2>{{banner.title}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,10,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Título Secundario</p>
                <h2 [innerHTML]="banner.title2"></h2>
              </div>
              <div class=" col-12" *ngIf="![7,10,16,17,18].includes(banner.reference)">
                <p class="input-label">Subtítulo</p>
                <h2>{{banner.subTitle}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,9].includes (banner.reference)">
                <p class="input-label">Subtítulo 2 </p>
                <h2>{{banner.subTitle2}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,7,9].includes(banner.reference)">
                <p class="input-label">Texto de Botón</p>
                <h2>{{banner.button1}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Texto de Botón</p>
                <h2>{{banner.button4}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,5,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Texto de Botón Agendar cita</p>
                <h2>{{banner.button1}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,9].includes(banner.reference)">
                <p class="input-label">Link redirección</p>
                <h2>{{banner.url1}}</h2>
              </div>
              <div class=" col-12 text-break" *ngIf="[2,6,4,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Link redirección</p>
                <h2>{{banner.url4}}</h2>
              </div>
              <div class="col-12 mb-5" *ngIf="[7].includes(banner.reference)">
                <p class="input-label">Logo Vida Plus</p>
                <h2 class="text-title2">{{banner.title2}}</h2>
                <img [src]="banner.title2" class="banner-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </perfect-scrollbar>
  </mat-tab>
  <mat-tab label="Deshabilitados ({{ inactiveArrData.length }})">
    <perfect-scrollbar class="slides-scrollbar disabled-content"
      [config]="{useBothWheelAxes: false, suppressScrollX: false, suppressScrollY: true}">
      <div class="slides-content">
        <div *ngFor="let banner of inactiveArrData, index as i">
          <mat-card class="banner has-outline-menu slider">
            <div class="vs-crud-menu">
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'"
                [matTooltip]="banner.status === 'Activo' ? 'Deshabilitar Banner' :  'Habilitar Banner'"
                (click)="changeStatus(banner, banner.status)">
                <mat-icon>{{ banner.status === 'Activo' ? 'visibility' : 'visibility_off' }}</mat-icon>
              </button>
              <button type="button" [disabled]="!mantenienceSection"
                [ngClass]="mantenienceSection ? 'vs-btn-crud' : 'vs-btn-crud-disabled'" matTooltip="Eliminar Banner"
                (click)="deleteFromDisable(banner)">
                <mat-icon>delete_forever</mat-icon>
              </button>
            </div>
            <h4 class="blue-text text-center" *ngIf="banner.orderId === 1">Slider Principal</h4>
            <!--      <p>{{banner.orderId}}.</p>-->
            <div class="row text-center">
              <div class="col-12 mb-5">
                <img [src]="banner.img" class="banner-preview" [alt]="banner.title">
              </div>
              <div class=" col-12">
                <p class="input-label">Título</p>
                <h2>{{banner.title}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,10,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Título Secundario</p>
                <h2 [innerHTML]="banner.title2"></h2>
              </div>
              <div class=" col-12" *ngIf="![7,10,16,17,18].includes(banner.reference)">
                <p class="input-label">Subtítulo</p>
                <h2>{{banner.subTitle}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,9].includes (banner.reference)">
                <p class="input-label">Subtítulo 2 </p>
                <h2>{{banner.subTitle2}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,7,9].includes(banner.reference)">
                <p class="input-label">Texto de Botón</p>
                <h2>{{banner.button1}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Texto de Botón</p>
                <h2>{{banner.button4}}</h2>
              </div>
              <div class=" col-12" *ngIf="[1,9].includes(banner.reference)">
                <p class="input-label">Link redirección</p>
                <h2>{{banner.url1}}</h2>
              </div>
              <div class=" col-12" *ngIf="[2,6,4,5,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Texto de Botón Agendar cita</p>
                <h2>{{banner.button1}}</h2>
              </div>
              <div class=" col-12 text-break" *ngIf="[2,6,4,11,12,13,15,14,16,17,18].includes(banner.reference)">
                <p class="input-label">Link redirección</p>
                <h2>{{banner.url4}}</h2>
              </div>
              <div class="col-12 mb-5" *ngIf="(banner.type === 7)">
                <p class="input-label">Logo</p>
                <img [src]="banner.title2" class="banner-preview" [alt]="banner.title"
                  onerror="this.onerror = null; this.src = 'assets/images/img-placeholder.png'">
              </div>
            </div>
          </mat-card>
        </div>
      </div>
    </perfect-scrollbar>
  </mat-tab>
</mat-tab-group>